module.exports = __webpack_public_path__ + "static/media/authentication.03abecef.svg";